import { RoleEnum } from 'src/common/external/bambi-api/bambiApi';

export const rideOrderingPortalUserTypes: RoleEnum[] = [
  'facility admin',
  'facility user',
];
